import React, { useEffect, useState, useContext, Fragment } from "react";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../../../context/AlertContext";
import constants from "../../../../../../constants";
import Loading from "../../../../../Notification-Loading/Loading/Loading";
import { isClosingSoon } from "../../../../../../util";
import Badge from "../../../../../CommonComponents/Badge";
import moment from "moment";
import { Link } from "react-router-dom";
import Tooltip from "../../../../../CommonComponents/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import { SOAHackathonsSkeleton } from "./SOAHackathonsSkeleton";

const SOAHackathons = () => {
  const { setShowNotify, setIsLoaded, isLoaded } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const [hackathons, setHackathons] = useState([]);
  // console.log("hackathons", hackathons);
  useEffect(() => {
    const fetchHackathons = async () => {
      try {
        setIsLoaded(true);
        const response = await axios.get("node/learner/hackathon", {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          setHackathons(response.data.data ?? []);
        } else
          setShowNotify({
            show: true,
            title: "Error!",
            msg:
              response.data.msg ??
              "Something went wrong. Please try again later or contact support.",
          });
      } catch (error) {
        console.error("Error fetching hackathon:", error);
        setShowNotify({
          show: true,
          title: error.message.includes("403") ? "Warning!" : "Error!",
          msg: error.message.includes("403")
            ? "You have been logged-out due to inactivity. Login again."
            : error.message ??
              "Something went wrong. Please try again later or contact support.",
          isUnAuth: error.message.includes("403"),
        });
      } finally {
        setIsLoaded(false);
      }
    };
    fetchHackathons();
  }, [axios, setShowNotify, setIsLoaded]);

  if(!hackathons?.length > 0 ){
    return(
      <SOAHackathonsSkeleton/>
    )
  }
  return (
    <div className="SOAHackathons-container">
        <>
          {" "}
          <div className="SOAHackathons-Header">Hackathons</div>
          <div className="SOAHAckathons-Content">
            {hackathons.map((data) => (
              <Link
                to={data.link}
                key={data.id}
                style={{ textDecoration: "none" }}
                target="_blank"
                className="SOAHackathonData-container"
              >
                <div className="SOAHackathonData">
                  <div className="SOAHackathonData-leftside">
                    <Tooltip title={data.title} placement="bottom">
                      <div className="SOAHackathonTitle">{data.title}</div>
                    </Tooltip>
                    {isClosingSoon(data.enddate) && (
                      <Badge
                        label={"Registration closing soon"}
                        color={"error"}
                      />
                    )}
                  </div>
                  <div className="SOAHackathonData-rightside">
                    {moment(data.enddate).format("DD/MM/yyyy")}
                  </div>
                </div>
                <hr />
              </Link>
            ))}
          </div>
          {isLoaded && (
            //  && MANAGEMENTROLES.includes(getDataFromStorage("role"))
            <Loading />
          )}
        </>
    </div>
  );
};

export default SOAHackathons;
